import request from "@/assets/request.js";
/**
 * 商品数字视频列表
 * @param data
 * @returns
 */
export const aiProductPage = (data) => {
  return request({
    url: `/api/merchant/digital/product/page`,
    method: "post",
    data,
  });
};

/**
 * 合成数字人
 * @param data
 * @returns
 */
export const SlDigitalHumanVideo = (data) => {
  return request({
    url: "/api/merchant/digitalHumanVideo/SlDigitalHumanVideo",
    method: "post",
    data,
  });
};

/**
 * 查询视频合成信息
 * @param data
 * @param data.bizId 业务id
 * @param data.bizType 业务类型 1、商品 2、店铺
 * @returns
 */
export const queryVideoProgressInfo = (data) => {
  return request({
    url: "/api/merchant/digital/human/query/video-progress",
    method: "post",
    data,
  });
};
/**
 * 查询排队数量
 * @returns
 */
export const queryVideoWaitNum = () => {
  return request({
    url: "/api/merchant/digital/human/query/wait-num",
    method: "post",
  });
};

/**
 * 保存视频到草稿箱
 * @returns
 */
export const saveTodraft = (data) => {
  return request({
    url: "/api/merchant/digital/human/save/video/to-draft",
    method: "post",
    data,
  });
};

/**
 * 视频排队等待
 * @returns
 */
export const videoQueue = (data) => {
  return request({
    url: "/api/merchant/digital/human/video/queue-up",
    method: "post",
    data,
  });
};


/**
 * 查询视频队列
 * @returns
 */
export const queueList = () => {
  return request({
    url: "/api/merchant/digital/human/query/video-task/queue",
    method: "post",
  });
};

/**
 * 取消视频队列任务
 * @returns
 */
export const cancelqueueTask = (id) => {
  return request({
    url: "/api/merchant/digital/human/cancel/video-task",
    method: "post",
    data:{
      id
    }
  });
};
// 数字人列表
export const digitalHumanPage = (data) => {
    return request({
      url: "/api/merchant/digital/human/page",
      method: "post",
      data,
    });
  };
  
  // 查询店铺数字人信息
  export const digitalHumanShopGet = () => {
    return request({
      url: "/api/merchant/digital/shop/get",
      method: "post",
    });
  };
  //排序
  export const updateAiVideo = (data) => {
    return request({
      url: "/api/merchant/digital/product/video-sort",
      method: "post",
      data
    });
  };
  
  //删除
  export const deleteAiVideo = (data) => {
    return request({
      url: "/api/merchant/digital/product/video-del",
      method: "post",
      data
    });
  };
  //商品列表
  export const getGoodsList = (data) => {
    return request({
      url: "/api/merchant/digital/product/pageProduct",
      method: "post",
      data
    });
  };
  //AI历史记录
  export const reqHistoryRecord = (data) => {
    return request({
      url: "/api/merchant/product/ai-record/page",
      method: "post",
      data
    });
  };
  //AI图片编辑
  export const reqAiImageEdit= (data) => {
    return request({
      url: "/api/merchant/product/ai-image-design",
      method: "post",
      data
    });
  };
  //AI图片结果参数
  export const reqAiImageEditResult= (data) => {
    return request({
      url: "/api/merchant/product/ai-image-design/query",
      method: "post",
      data
    });
  };
    //保存设计完的图片
    export const saveAiImage= (data) => {
      return request({
        url: "/api/merchant/product/ai-image-design/save",
        method: "post",
        data
      });
    };
  //AI文生文
  export const reqAiCopyWriting= (data) => {
    return request({
      url: "/api/merchant/product/ai-text/add",
      method: "post",
      data
    });
  };
  //AI文生图
  export const reqAiImageWriting= (data) => {
    return request({
      url: "/api/merchant/product/ai-image/add",
      method: "post",
      data
    });
  };
  //查询AI文生图
  export const reqAiImageWritingResult= (data) => {
    return request({
      url: "/api/merchant/product/ai-image/query",
      method: "post",
      data
    });
  };
  //AI文生视频
  export const reqAiVideoWriting= (data) => {
    return request({
      url: "/api/merchant/product/ai-video/add",
      method: "post",
      data
    });
  };
  //查询AI文生视频
  export const reqAiVideoWritingResult= (data) => {
    return request({
      url: "/api/merchant/product/ai-video/query",
      method: "post",
      data
    });
  };
  //商品详情查询
  export const reqGoodsDetail= (data) => {
    return request({
      url: "/api/merchant/product/ai-content/query",
      method: "post",
      data
    });
  };
  
  //设为商品对应内容
  export const reqSetGoods= (data) => {
    return request({
      url: "/api/product/ai-content/setting",
      method: "post",
      data
    });
  };
/**
 * 查询生成AI文字模型列表
 * @returns
 */
export const reqGeneralAiWriteList = (data) => {
  return request({
    url: "api/merchant/digital/human/ai-text/page",
    data,
    method: "post",
  });
};

  
